import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setToken, getToken } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // status: 'checking' | 'authed' | 'anon'
  const [status, setStatus] = useState("checking");
  const [user, setUser] = useState(null);

  useEffect(() => {
    const tok = getToken();
    if (!tok) {
      setStatus("anon");
      return;
    }
    (async () => {
      try {
        const me = await api.get("/api/auth/me");
        setUser(me);
        setStatus("authed");
      } catch {
        setToken(null);
        setStatus("anon");
      }
    })();
  }, []);

  const login = useCallback(async (username, password, companyUsername) => {
    const data = await api.post("/api/auth/login", {
      username,
      password,
      company_username: companyUsername || undefined,
    });
    setToken(data.token);
    setUser(data.user);
    setStatus("authed");
    return data.user;
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setUser(null);
    setStatus("anon");
  }, []);

  const refresh = useCallback(async () => {
    try {
      const me = await api.get("/api/auth/me");
      setUser(me);
    } catch {
      /* ignore */
    }
  }, []);

  return (
    <AuthContext.Provider value={{ status, user, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
